import React from 'react';
import { useLandingPageState, useLandingPageActions } from './LandingPageContext';
import { useCapabilities } from '../../Shared/capabilities';
import InvitationRequestWizard from '../../InvitationRequestWizard/components/InvitationRequestWizard';

const WizardsSection = () => {
  const state = useLandingPageState();
  const { closeInvitationRequestWizard } = useLandingPageActions();
  const capabilities = useCapabilities();

  return (
    <>
      {capabilities.showRequestInvitationNavigation && (
        <InvitationRequestWizard
          showInvitationRequestWizard={state?.showInvitationRequestWizard}
          closeInvitationRequestWizard={closeInvitationRequestWizard}
        />
      )}
    </>
  );
};

export default WizardsSection;